
import React from "react";
import Cavalli from "../imgs/Cavalli_Musica-removebg-preview.png";
import Municipio4 from "../imgs/municipio_4-removebg-preview.png";
import Municipio5 from "../imgs/municipio_5-removebg-preview.png";
import { GiThreeFriends } from "react-icons/gi";
import { FaHandshake } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";

const Partners = () => {
  const partners = [
    {
      img: Cavalli,
      alt: "Cavalli Musica",
      title: "Cavalli Musica",
    },
    {
      img: Municipio4,
      alt: "Municipio 4",
      title: "Municipio 4",
    },
    {
      img: Municipio5,
      alt: "Municipio 5",
      title: "Municipio 5",
    },
  ];

  return (
<div className="flex flex-col items-center w-full min-h-screen bg-gradient-to-r from-white to-amber-50 text-gray-800 overflow-hidden">
      {/* =========================================================
          DECORAZIONI DI SFONDO
      ========================================================= */}
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-red-100/40 blur-3xl" />

      <div className="pointer-events-none absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-amber-200/40 blur-3xl" />

      <GiThreeFriends
        className="pointer-events-none fixed -right-5 -top-5 z-0 rotate-12 text-[180px] text-amber-200/30"
      />


      {/* =========================================================
          CONTENUTO
      ========================================================= */}
      <main className="relative z-10 mx-auto flex w-11/12 max-w-6xl flex-col items-center ">


        {/* =========================================================
            INTESTAZIONE
        ========================================================= */}
        <header className="mb-12 text-center">
          <h1 className=" text-4xl font-extrabold tracking-wide text-red-600 md:text-5xl">
            I nostri Partners
          </h1>

          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-gray-600 md:text-lg">
            La musica cresce grazie alla collaborazione e al sostegno di
            realtà che condividono con noi la voglia di creare cultura,
            incontri e nuove opportunità.
          </p>

        </header>


        {/* =========================================================
            PARTNERS
        ========================================================= */}
        <section className="w-full">

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">

            {partners.map((partner) => (

              <article
                key={partner.title}
                className="group relative flex min-h-[280px] flex-col items-center justify-between overflow-hidden rounded-3xl border border-amber-100 bg-white/80 p-6 shadow-lg backdrop-blur-md transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
              >

                {/* Decorazione superiore */}
                <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-red-600 via-red-500 to-amber-400 opacity-80" />


                {/* Icona */}
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600 transition-all duration-500 group-hover:scale-110 group-hover:bg-red-600 group-hover:text-white">

                  <FaHandshake  className="text-xl" />

                </div>


                {/* Logo */}
                <div className="flex h-36 w-full items-center justify-center px-4">

                  <img
                    src={partner.img}
                    alt={partner.alt}
                    className="max-h-32 max-w-[85%] object-contain transition-transform duration-500 group-hover:scale-110"
                  />

                </div>


                {/* Nome */}
                <div className="flex w-full items-center justify-between border-t border-gray-100 pt-4">

                  <h2 className="text-base font-bold text-gray-800">
                    {partner.title}
                  </h2>

                </div>

              </article>

            ))}

          </div>

        </section>


        {/* =========================================================
            FRASE FINALE
        ========================================================= */}
        <section className="mt-12 mb-5 w-full rounded-3xl bg-red-700 px-6 py-10 text-center text-white shadow-xl md:px-12">

          <FaHandshake  className="mx-auto mb-4 text-4xl text-amber-200" />

          <h2 className="text-2xl font-bold md:text-3xl">
            La collaborazione fa crescere la musica
          </h2>

          <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-red-50 md:text-lg">
            Grazie a tutte le realtà che scelgono di accompagnare MilArte
            nel suo percorso e di contribuire alla diffusione della cultura
            musicale.
          </p>

        </section>




      </main>
    </div>
  );
};

export default Partners;
